import Head from 'next/head';
import { type FC } from 'react';
import { Box } from '@zillow/constellation-10';
import { MaybeLoanID } from 'src/common/types';
import { DashboardPageLayout } from './components/DashboardPageLayout/DashboardPageLayout';
import { WiredResourceCard } from './modules/ResourceCard/ResourceCard.wired';
import { WiredViewSavedInformation } from './modules/ViewSavedInformation/ViewSavedInformation.wired';
import { WiredTeamInformationCard } from './modules/TeamInformationCard/TeamInformationCard.wired';
import { useMortgageDashboardState } from './state/useMortgageDashboardState';
import { WiredHeroGraphic } from './modules/HeroGraphic/HeroGraphic.wired';
import { WiredUpsell } from './modules/Upsell/Upsell.wired';
import { ServerSideModuleData } from './GetServerSideProps/utils/getServerSideModuleData';
import { WiredWelcomeBanner } from './modules/WelcomeBanner/WelcomeBanner.wired';

export type MortgageDashboardProps = {
    serverFetchedData: ServerSideModuleData;
    loanID: MaybeLoanID;
};

export const WiredMortgageDashboard: FC<MortgageDashboardProps> = ({ serverFetchedData, loanID }) => {
    useMortgageDashboardState({ loanID });
    return (
        <>
            <Head>
                <title>Dashboard | Zillow Home Loans</title>
            </Head>
            <DashboardPageLayout
                welcomeBannerModule={<WiredWelcomeBanner serverFetchedData={serverFetchedData} loanID={loanID} />}
                upsellModule={<WiredUpsell serverFetchedData={serverFetchedData} loanID={loanID} />}
                heroGraphicModule={<WiredHeroGraphic serverFetchedData={serverFetchedData} loanID={loanID} />}
                resourceModule={<WiredResourceCard serverFetchedData={serverFetchedData} loanID={loanID} />}
                viewSavedInformationModule={
                    <WiredViewSavedInformation serverFetchedData={serverFetchedData} loanID={loanID} />
                }
                teamInformationModule={<WiredTeamInformationCard serverFetchedData={serverFetchedData} />}
            />
            <Box css={{ height: 'lg' }} />
        </>
    );
};
